import React from 'react';
import { motion } from 'framer-motion';

const artists = [
  { id: 1, name: "출장작곡가 김동산", time: "16:00 - 16:15", description: "IS 수장의 입단 환영 공연", url: "https://www.instagram.com/long_player_" },
  { id: 2, name: "Nahua", time: "16:15 - 16:30", description: "멕시코 아즈텍 듀오 메탈 / 앰비언트", url: "https://www.instagram.com/nahuamx/" },
  { id: 3, name: "박연두", time: "16:30 - 16:45", description: "앨범 [가끔 내 방에는 바다가 밀려온다]를 구매하세요..!", url: "https://www.instagram.com/grassgreenpark/" },
  { id: 4, name: "하루살이프로젝트", time: "16:45 - 17:00", description: "멋쟁이 싱어송라이터", url: "https://www.instagram.com/9.17.p.m/" },
  { id: 5, name: "희우", time: "17:00 - 17:15", description: "판소리 소리꾼이면서 싱어송라이터이기도 하다..!", url: "https://www.instagram.com/heewoo_7/" },
  { id: 6, name: "까르", time: "17:15 - 17:30", description: "전환 파워!!!", url: "https://www.instagram.com/caru1011/" },
  { id: 7, name: "themilliways", time: "17:30 - 17:45", description: "우주의 끝에서 온 앰비언트", url: "https://www.instagram.com/themilliways_official/" },
  { id: 8, name: "신명", time: "17:45 - 18:00", description: "일단 한번 들어보시라니깐요..?!", url: "https://www.instagram.com/yeoouul/" },
  { id: 9, name: "Sabbaha", time: "18:00 - 18:15", description: "경찰과의 몸싸움 준비..!", url: "https://www.instagram.com/sabbaha_kr/" },
  { id: 10, name: "ANAZAO", time: "18:15 - 18:30", description: "모두들 탕아의 회귀를 목도하라", url: "https://www.instagram.com/anazao.official/" },
  { id: 11, name: "남수", time: "18:30 - 18:45", description: "뛰어난 연주와 탁월한 음색", url: "https://www.instagram.com/namsu_ggu/" },
  { id: 12, name: "박치치", time: "18:45 - 19:00", description: "불광동 음유시인", url: "https://www.instagram.com/blackaftermoon/" },
  { id: 13, name: "유동혁", time: "19:00 - 19:15", description: "터프하지만 실체가 담겨있는 포크송", url: "https://www.instagram.com/blackaftermoon/" },
  { id: 14, name: "Around Surround", time: "19:15 - 19:30", description: "내면의 소리를 연주하는 시타르 주자", url: "https://www.instagram.com/around_surround/" }
];

function LineupSchedule() {
  return (
    <section id="lineup" className="py-20 bg-retro-orange">
      <div className="container mx-auto px-4">
        <motion.h2 
          className="text-4xl font-bold mb-12 text-center text-purple-haze"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          🎵 라인업 & 일정 🕒
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-5 lg:grid-cols-5 gap-8">
          {artists.map((artist) => (
            <motion.div 
              key={artist.id} 
              className="bg-acid-green bg-opacity-20 p-6 rounded-lg shadow-lg transform hover:scale-105 transition duration-300 cursor-pointer"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: artist.id * 0.1, duration: 0.5 }}
              whileHover={{ scale: 1.05, boxShadow: "0px 0px 8px rgba(255,255,255,0.5)" }}
              whileTap={{ scale: 0.95 }}
              onClick={() => window.open(artist.url, "_blank")}
            >
              <h3 className="text-2xl font-subtitle mb-2 text-white">{artist.name}</h3>
              <p className="text-electric-blue mb-4">{artist.time}</p>
              <p className="text-acid-green">{artist.description}</p>
            </motion.div>
          ))}
        </div>
        <motion.p 
          className="mt-12 text-center text-xl text-purple-haze"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          ⚠️ 공연 시간과 출연진은 아티스트의 기분에 따라 갑자기 바뀔 수 있습니다! ⚠️
        </motion.p>
      </div>
    </section>
  );
}

export default LineupSchedule;